var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9L6.87707 5.24801C7.6846 4.63201 9.11903 4.59 9.99031 5.171L10.9997 5.83601C11.871 6.41001 13.3054 6.375 14.113 5.759L19.0007 2",
    stroke: "#7D899D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3008 7.5C18.3008 6.94772 18.7485 6.5 19.3008 6.5H20.5009C21.0532 6.5 21.5009 6.94772 21.5009 7.5V21C21.5009 21.2761 21.2771 21.5 21.0009 21.5H18.8008C18.5246 21.5 18.3008 21.2761 18.3008 21V7.5Z",
    stroke: "#7D899D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0469 10.5C13.0469 9.94772 13.4946 9.5 14.0469 9.5H15.247C15.7993 9.5 16.247 9.94772 16.247 10.5V21C16.247 21.2761 16.0232 21.5 15.747 21.5H13.5469C13.2707 21.5 13.0469 21.2761 13.0469 21V10.5Z",
    stroke: "#7D899D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79688 13.5C7.79688 12.9477 8.24459 12.5 8.79688 12.5H9.99704C10.5493 12.5 10.997 12.9477 10.997 13.5V21C10.997 21.2761 10.7732 21.5 10.497 21.5H8.29688C8.02073 21.5 7.79688 21.2761 7.79688 21V13.5Z",
    stroke: "#7D899D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54688 16.5C2.54688 15.9477 2.99459 15.5 3.54688 15.5H4.74704C5.29932 15.5 5.74704 15.9477 5.74704 16.5V21C5.74704 21.2761 5.52318 21.5 5.24704 21.5H3.04688C2.77073 21.5 2.54688 21.2761 2.54688 21V16.5Z",
    stroke: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart_bar.82ef3bb12053828c25173d8feea2b68c.svg";
export { ForwardRef as ReactComponent };